import Component from '../../classes/Component';
import {$dom} from '../../helpers/dom';
import variables from '../../variables';
import {$events} from "../../helpers/events";
import {gsap} from 'gsap';
import Choices from 'choices.js';
import {isElement} from "../../helpers/_utilities";

const withOtherFieldSelectSelector = '.js-custom-select-with-other-field';
const boundOtherFieldAttr = 'data-other-select-id';
const selectOtherSelector = '.js-select-other';

export default function () {

	return new Component({
		name: 'select',
		requiredTargets: variables.selectors.select,
		onCreate() {
            this.fields = {};
        },
		onInit() {
            this.addField = field => {
                const
                    fieldId = $dom.attr(field, 'id')
                ;

                if (Choices) {
                    let searchEnabled = true;
                    const enabledAttr = $dom.attr(field, 'data-search-enabled');

                    if (enabledAttr)
                        searchEnabled = enabledAttr !== 'false'


                    this.fields[fieldId] = new Choices(field, {
                        ...variables.choicesOptions,
                        placeholder: true,
                        searchEnabled
                    });

                    return this.fields[fieldId]
                }

                return null;
            }

            this.otherField = {
                getBound(selectEl) {
                    let field = null, parent = null;
                    const fieldSelector = `[${boundOtherFieldAttr}="${selectEl.getAttribute('id')}"]`;

                    if ($dom.exist(fieldSelector)) {
                        field = $dom.get(fieldSelector);

                        parent = $dom.getParent(field, selectOtherSelector);
                    }

                    return {field, parent}
                },
                show(selectEl) {
                    if (!isElement(selectEl)) return;

                    if (!selectEl.savedNameAttr)
                        selectEl.savedNameAttr = selectEl.getAttribute('name');

                    const {field, parent} = this.getBound(selectEl);

                    if (field && parent && selectEl.savedNameAttr) {
                        $dom.removeClass(parent, 'd-none');
                        field.setAttribute('name', selectEl.savedNameAttr);
                        selectEl.removeAttribute('name');

                        gsap.fromTo(parent, {
                            xPercent: 5,
                            autoAlpha: 0
                        }, {
                            xPercent: 0,
                            autoAlpha: 1
                        });

                        return field
                    }
                },
                hide(selectEl) {
                    if (!isElement(selectEl)) return;

                    const {field, parent} = this.getBound(selectEl);

                    if (field && parent) {
                        const selectId = selectEl.getAttribute('id');

                        if (!selectId || !selectEl.savedNameAttr) return;

                        selectEl.setAttribute('name', selectEl.savedNameAttr);
                        field.removeAttribute('name');

                        gsap.fromTo(parent, {
                            xPercent: 0,
                            autoAlpha: 1
                        }, {
                            xPercent: 5,
                            autoAlpha: 0,
                            onComplete: () => {
                                $dom.addClass(parent, 'd-none');
                                field.value = '';
                            }
                        })
                    }
                }
            }

            this.handleSelectOtherChoice = event => {
                const {detail, target} = event;
                const {value} = detail.choice;

                if (value === 'other') {
                    this.otherField.show(target);
                } else {
                    this.otherField.hide(target);
                }
            }

            $dom.each(this.targets, this.addField);

            $events.delegate.on('choice', withOtherFieldSelectSelector, this.handleSelectOtherChoice)
        },
		onDestroy() {
            Object.values(this.fields).forEach(ch => {
                if(ch instanceof Choices) ch.destroy();
            });

            this.fields = {};
        }
	})
}
